import { getHex } from "@/theme"
import React, { SVGProps } from "react"

export const RefreshIcon: React.FC<SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M1.66667 11.6667C1.66667 11.6667 1.76777 12.3744 4.6967 15.3033C7.62563 18.2322 12.3744 18.2322 15.3033 15.3033C16.341 14.2656 17.0111 12.9994 17.3135 11.6667M1.66667 11.6667V16.6667M1.66667 11.6667H6.66667M18.3333 8.33333C18.3333 8.33333 18.2322 7.62563 15.3033 4.6967C12.3744 1.76777 7.62563 1.76777 4.6967 4.6967C3.65897 5.73443 2.98891 7.0006 2.68652 8.33333M18.3333 8.33333V3.33333M18.3333 8.33333H13.3333"
        stroke={props.stroke || getHex("fg-1")}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
